(function () {
  'use strict';

  angular
    .module('admin.checklist.users.service', [])
    .factory('ChecklistUsersService', ChecklistUsersService);

  /** @ngInject */
  function ChecklistUsersService($http, $q, API) {

    function list(id, start, limit, qua, completed) {
      var defered = $q.defer();

      $http.get(API.API_URL + 'admin/checklist_definitions/' + id + '/checklists?start=' + start + '&limit=' + limit + '&qua=' + qua + '&completed=' + completed)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      list: list,
    };

  }

})();
